import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccLead } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { AdmissionsAreaService } from '../../../../admissions-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService, admissionsAreaService: AdmissionsAreaService): GridSetup<AccLead> {

	return {
		rowName: { singular: 'Closed Lead', plural: 'Closed Leads' },
		getRowKey: row => '' + row.accLeadId,
		stateKey: 'prospects-closed-leads-grid',
		actions: getActions(dialogService, admissionsAreaService),
		buttons: [],
		columns: getColumns(util, domainData, app),
	}
}
